export default "__VITE_ASSET__aUFXbisI__"